export function StarSVG() {
  return (
    <svg
      className='h-full w-full'
      fill='#FFDD00'
      height='251'
      viewBox='0 0 259 251'
      width='259'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M192.708 248.97L136.614 220.512C132.456 217.733 125.197 217.399 122.094 219.843L66.8903 249.215C55.5042 255.159 40.9532 245.433 43.6728 232.189L54.5196 170.157C55.1917 164.581 54.1368 159.357 49.6277 154.837L4.88813 111.377C-4.13012 102.336 -0.386762 85.2585 13.7815 84.1858L74.9322 75.3574C80.1134 74.3021 84.9427 71.5057 87.3419 65.5786L115.491 9.08625C122.016 -3.11975 138.263 -2.80295 144.179 8.6821L171.679 64.7178C174.461 69.5897 178.619 72.3687 184.151 73.0547L245.365 82.342C258.509 85.1034 263.401 100.423 254.445 109.498L209.315 153.133C204.837 157.671 203.813 161.505 204.868 166.729L215.449 228.023C218.966 245.435 204.829 255.566 192.708 248.97Z'
        fill='#FFDD00'
      />
    </svg>
  );
}
